<template>
  <div>
    <main-layout>
      <v-tabs v-model="tabs" color="white" :slider-color="$store.state.theme.brand_color">
        <v-tab ripple :key="'product'" :href="'#product'">{{ $t('Product') }}</v-tab>
        <!-- <v-tab ripple :key="'branch'" :href="'#branch'">{{ $t('Branch') }}</v-tab> -->
      </v-tabs>

      <!-- <div v-if="tabs == 'branch'">
        <Branch></Branch>
      </div> -->
      <div v-if="tabs == 'product'">
        <Product></Product>
      </div>
    </main-layout>
  </div>
</template>

<script>
// import Branch from './Branch.vue'
import Product from './Product.vue'
export default {
  components: {
    // Branch,
    Product
  },
  data() {
    return {
      tabs: 'product'
    }
  },
  created() {
    // let vm = this
    // if (vm.$route.query.tab) {
    //   vm.tabs = vm.$route.query.tab
    // } else {
    //   vm.tabs = 'product'
    // }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/lamy/ProductAndBranch/main.vue